<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M9.65032 3.98098L13.4258 7.75643M9.05707 16.5H16.5M12.1313 1.5L1.5 12.1313L1.5 15.9067H5.27545L15.9067 5.27545L12.1313 1.5Z" stroke="#0E150E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
